export const SunriseType = {
  All: 0,
  Sunrise: 1,
  Sunset: 2,
};
